import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StoreContexto } from '../Contexto/Provider';

import '../Estilos/Componentes.css';
import '../Estilos/Container.css';
import '../Estilos/Dropdown.css';
import BotaoCabecalho from './BotaoCabecalho';
import ModalConfirmacao from './ModalConfirmacao';

export default function Cabecalho(props) {
  const [open, setopen] = useState(false);
  const { auth, setAuth } = useContext(StoreContexto);

  const { nomeSalvo } = auth;

  const [modalConfirmacaoVisivel, setModalConfirmacaoVisivel] = useState(false);

  const navigate = useNavigate();

  return (
    <div className="Cabecalho">
      <img
        className="header_logo"
        src={require('../Icones/LOGOJABILB.svg').default}
        width={100}
        height={50}
        alt="jabil logo"
        onClick={() => {
          navigate('/wellcome');
        }}
      />

      {modalConfirmacaoVisivel ? (
        <ModalConfirmacao
          aviso="Deseja realmente sair do sistema?"
          externo
          clicadoVolta={() => {
            setModalConfirmacaoVisivel(false);
            setopen(false);
          }}
          clicado={async () => {
            setModalConfirmacaoVisivel(false);
            localStorage.clear();
            setopen(false);
            setAuth({ token: '', idLogin: -1, controleSalvo: '', nomeSalvo: '' });
          }}
        />
      ) : null}

      <div className={`Dropdown`}>
        <div
          className="DropdownNome"
          onClick={() => {
            setopen(!open);
          }}
        >
          <p className="DropdownNome">Olá, {nomeSalvo}</p>
          <img
            className="DropdownNome"
            src={require('../Icones/setinha.svg').default}
            height={15}
            width={15}
            alt="Menu"
          />
        </div>

        {open && (
          <div className="DropdownBackground" onClick={() => {}}>
            <h1 className="DropdownBackground">{nomeSalvo}</h1>

            {auth.perfilSalvo !== 'OWNER' && (
              <>
                <div className="DivMenu" />
                <BotaoCabecalho
                  imagem={require('../Icones/icon dados cadastrais.svg').default}
                  texto="Dados Cadastrais"
                  clicado={() => {
                    navigate('/my-data');
                    setopen(false);
                  }}
                />
              </>
            )}

            <div className="DivMenu" />

            <BotaoCabecalho
              imagem={require('../Icones/icon sair.svg').default}
              texto="Sair"
              clicado={() => {
                setModalConfirmacaoVisivel(true);
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
